export const typeDictionary = {
    'graduate': 'Graduate',
    'undergraduate': 'Undergraduate',
    'transfer': 'Transfer',
    'highSchool': 'High School',
  }